import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactDetailModel } from '../../../../../../shared/store/contact/types';
import { ContactService } from '../../../../../../shared/store/contact/contact.service';

@Component({
  selector: 'app-contact-details-calls',
  templateUrl: './contact-details-calls.component.html',
  styleUrl: './contact-details-calls.component.scss',
  standalone: false,
})
export class ContactDetailsCallsComponent {
  contactDetail$: Observable<ContactDetailModel>;

  constructor(private readonly contactService: ContactService) {
    this.contactDetail$ = this.contactService.getById.value$;
  }
}
